function formatearRUT(rut) {
  rut = rut.replace(/[^0-9kK]/g, '').toUpperCase();

  if (rut.length === 0) return '';
  if (rut.length === 1) return rut;

  let cuerpo = rut.slice(0, -1);
  let dv = rut.slice(-1);

  cuerpo = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return `${cuerpo}-${dv}`;
}

function validarRUT(rutCompleto) {
  // Limpiar puntos antes del regex (formatearRUT devuelve con puntos ej: 15.774.247-7)
  let rutLimpio = rutCompleto.replace(/\./g, '');
  if (!/^[0-9]+-[0-9kK]{1}$/.test(rutLimpio)) return false;
  
  let [cuerpo, dv] = rutLimpio.split('-');
  let suma = 0;
  let multiplo = 2;
  
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += multiplo * parseInt(cuerpo.charAt(i));
    multiplo = multiplo < 7 ? multiplo + 1 : 2;
  }
  
  let dvEsperado = 11 - (suma % 11);
  dvEsperado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();
  
  return dv.toUpperCase() === dvEsperado;
}

window.onload = () => {
  const rutInput = document.getElementById("rut");
  const submitBtn = document.querySelector('input[type="submit"]');
  const form = document.querySelector('form');

  if (rutInput) {
    // Deshabilitar botón por defecto si está vacío
    if (submitBtn && rutInput.value === '') {
      submitBtn.disabled = true;
    }

    rutInput.addEventListener("input", function () {
      const start = this.selectionStart;

      let raw = this.value.replace(/[^0-9kK]/g, '');
      let formateado = formatearRUT(raw);

      this.value = formateado;

      if (raw.length > 7) {
        if (validarRUT(formateado)) {
          this.classList.remove("is-invalid");
          this.classList.add("is-valid");
          if (submitBtn) submitBtn.disabled = false;
        } else {
          this.classList.remove("is-valid");
          this.classList.add("is-invalid");
          if (submitBtn) submitBtn.disabled = true;
        }
      } else {
        this.classList.remove("is-valid", "is-invalid");
        if (submitBtn) submitBtn.disabled = true;
      }

      this.setSelectionRange(formateado.length, formateado.length);
    });

    // Seguridad adicional: prevenir envío manual (ej: apretando Enter)
    if (form) {
      form.addEventListener('submit', function(e) {
        if (rutInput.classList.contains("is-invalid") || rutInput.value === '') {
          e.preventDefault();
        }
      });
    }
  }
}